import React from 'react'
import { PhotoSwipeGallery } from 'react-photoswipe'
import 'react-photoswipe/lib/photoswipe.css'
import renderContent from '../../utilities/renderContent'
import './style.css'

class NewsMedia extends React.PureComponent {
  constructor(props) {
    super(props)

    props.data.newsMedia.map((news, index) => {
      if (news.images) {
        news.images.map((image, index) => {
          if (image.src) {
            this.preloadImages.push(image.src)
          }
        })
      }
    })

    this.preloadImages.map((imageSource, index) => {
      this.preloadImage(imageSource)

      return imageSource
    })
  }

  preloadImages = []

  preloadImage = (imageSource) => {
    const img = new Image()

    img.onload = () => {
      this.preloadImages.splice(imageSource, 1)

      this.setState({
        [imageSource]: {
          width: img.width,
          height: img.height,
        }
      })
    }

    img.src = imageSource
  }

  render() {
    if (this.preloadImages.length) {
      return null
    }
    const { data } = this.props
    const getThumbnailContent = (item) => {
      return (
        <img className="thumbnail"
          src={item.src}
          width={item.width}
          height={item.height}
        />
      )
    }

    return (
      <div className="news-media">
        <div className="container">
          <div className="content">
            <h1 className="title">News & Media</h1>
            <div className="list">

              {
                data.newsMedia.map((news, index) => {
                  return (
                    <div className="item" key={index}>
                      <h2 className="label">
                        {news.label}
                      </h2>
                      {!!news.content &&
                        <div className="content">
                          {renderContent(news.content)}
                        </div>
                      }
                      {!!news.images && news.images.length &&
                        <PhotoSwipeGallery
                          items={news.images.reduce((items, item) => {
                            if (item.src) {
                              items.push({
                                src: item.src,
                                w: this.state[item.src].width,
                                h: this.state[item.src].height,
                                title: item.caption || `Image ${items.length + 1}`,
                              })
                            }
                            return items
                          }, [])}
                          options={{
                            galleryUID: (index + 1),
                            history: false,
                            focus: true,
                            bgOpacity: 0.7,
                          }}
                          thumbnailContent={getThumbnailContent}
                        />
                      }
                    </div>
                  )
                })
              }

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NewsMedia



// WEBPACK FOOTER //
// ./src/components/NewsMedia/index.js